"use client";

import { useMemo } from "react";
import Cookies from "js-cookie";
import { CONSTANTS_KEYS } from "@/constants/store";
import { User } from "@/interfaces/user.interface";

export function useCurrentUser(): Partial<User> | null {
  return useMemo(() => {
    try {
      const raw = Cookies.get(CONSTANTS_KEYS.USER);
      return raw ? (JSON.parse(raw) as Partial<User>) : null;
    } catch {
      return null;
    }
  }, []);
}
